export enum EditEquipmentTab {
  INFOS = 'infos',
  WHITELIST_BLACKLIST = 'whitelistBlacklist',
  DETECTIONS = 'detections',
  MODERATIONS = 'moderations',
}
